import type { Dictionary } from '../i18n.js';

export const wizard: Dictionary = {
  // raceWizard.ts
  Where: 'Gdzie',
  Area: 'Obszar',
  'Start & finish': 'Start i meta',
  Route: 'Trasa',
  Check: 'Sprawdzenie',
  'To continue': 'Żeby przejść dalej',
  'Discard this race? The box and pins you placed will be lost.':
    'Porzucić ten wyścig? Narysowany prostokąt i postawione pinezki przepadną.',
  'Your own region': 'Twój własny obszar',
  'Choose a built-in region or draw your own': 'Wybierz gotowy obszar albo narysuj własny',
  'Nothing is chosen yet. Pick one of the regions above, or “Draw on the map”.':
    'Nic jeszcze nie wybrano. Wybierz jeden z obszarów powyżej albo „Narysuj na mapie”.',
  'Give the race a name': 'Nazwij wyścig',
  'The race needs a name — it is what the tour card and the results call it.':
    'Wyścig potrzebuje nazwy — pod nią pojawi się na karcie turnieju i w wynikach.',
  'The region builds into a race': 'Z obszaru da się zbudować wyścig',
  'The server could not make a race here — its reason is above. Go back and move the box or the pins, or press “Try again” if the problem was the network.':
    'Serwer nie zdołał zrobić tu wyścigu — powód jest powyżej. Wróć i przesuń prostokąt albo pinezki, albo naciśnij „Spróbuj ponownie”, jeśli zawiodła sieć.',
  'Still building the region to check it can be raced. A built-in region takes a second; somewhere new can take a minute while its streets download.':
    'Obszar wciąż się buduje, żeby sprawdzić, czy da się na nim ścigać. Gotowy obszar zajmuje sekundę; nowe miejsce może potrwać minutę, zanim pobiorą się jego ulice.',
  'Checked with the server': 'Sprawdzone przez serwer',
  'The server could not be reached to check this region. You can still use it, but it may fail to load when the race starts.':
    'Nie udało się połączyć z serwerem, żeby sprawdzić ten obszar. Nadal możesz go użyć, ale może się nie wczytać, gdy wyścig wystartuje.',
  'Step {n} of {total}': 'Krok {n} z {total}',
  'Where is this race?': 'Gdzie ma być ten wyścig?',
  'Start from one of the built-in regions — they load in seconds and work with no network — or draw a box anywhere in the world.':
    'Zacznij od jednego z gotowych obszarów — wczytują się w kilka sekund i działają bez sieci — albo narysuj prostokąt w dowolnym miejscu na świecie.',
  'Mark out the area': 'Wyznacz obszar',
  'Place the start and the finish': 'Ustaw start i metę',
  'Click the map to drop the start, then click again for the finish. Both snap to the nearest street when the city is built, so close is good enough.':
    'Kliknij mapę, żeby postawić start, a potem jeszcze raz, żeby postawić metę. Przy budowaniu miasta obie pinezki przeskoczą na najbliższą ulicę, więc wystarczy trafić w pobliże.',
  'Shape the race': 'Ukształtuj wyścig',
  'Optional. Leave both as they are and the race takes the quickest way from start to finish, with checkpoints spaced along it.':
    'Opcjonalnie. Zostaw oba ustawienia bez zmian, a wyścig pojedzie najszybszą drogą ze startu na metę, z punktami kontrolnymi rozłożonymi po drodze.',
  'Check the race': 'Sprawdź wyścig',
  'The server builds the region once to make sure it can be raced. The highlighted line on the map is the route the cars will drive.':
    'Serwer raz buduje obszar, żeby się upewnić, że da się na nim ścigać. Podświetlona linia na mapie to trasa, którą pojadą auta.',
  'Draw on the map': 'Narysuj na mapie',
  'Any city, any streets — up to {max} km²': 'Dowolne miasto, dowolne ulice — do {max} km²',
  'Find the place. ': 'Znajdź miejsce. ',
  'Draw a box. ': 'Narysuj prostokąt. ',
  'Use current view': 'Użyj bieżącego widoku',
  'Clear box': 'Usuń prostokąt',
  'no box yet': 'brak prostokąta',
  'of {max} km²': 'z {max} km²',
  'Which pin the next click places': 'Którą pinezkę postawi następne kliknięcie',
  Start: 'Start',
  Finish: 'Meta',
  'Clear both pins': 'Usuń obie pinezki',
  placed: 'jest',
  'not placed': 'brak',
  'Click the map to move the start.': 'Kliknij mapę, żeby przesunąć start.',
  'Click the map to place the start.': 'Kliknij mapę, żeby postawić start.',
  'Click the map to move the finish.': 'Kliknij mapę, żeby przesunąć metę.',
  'Click the map to place the finish.': 'Kliknij mapę, żeby postawić metę.',
  'Drag a pin to move it, or pick Start or Finish above and click the map.':
    'Przeciągnij pinezkę, żeby ją przesunąć, albo wybierz powyżej Start lub Metę i kliknij mapę.',
  '{distance} apart as the crow flies — the race itself follows the streets.':
    '{distance} w linii prostej — sam wyścig pojedzie ulicami.',
  'Choose the start direction': 'Wybierz kierunek startu',
  'An arrow appears on the start pin. Drag it round and the race sets off that way.':
    'Na pinezce startu pojawi się strzałka. Obróć ją, a wyścig ruszy w tę stronę.',
  Checkpoints: 'Punkty kontrolne',
  Automatic: 'Automatycznie',
  'How many': 'Ile',
  'On the map': 'Na mapie',
  'Checkpoints along the route': 'Punkty kontrolne na trasie',
  'Remove all': 'Usuń wszystkie',
  'Gates every car has to pass through, in order, so nobody cuts across town.':
    'Bramki, przez które każde auto musi przejechać po kolei, żeby nikt nie skracał sobie drogi przez miasto.',
  'Sets off {bearing} — drag the arrow on the map to turn it.':
    'Kierunek startu: {bearing} — obróć strzałkę na mapie, żeby go zmienić.',
  'Off: the race leaves whichever way the quickest route goes.':
    'Wyłączone: wyścig ruszy tam, dokąd prowadzi najszybsza trasa.',
  '{n} of {max} placed. Click the map for another, click one to remove it, drag one to move it. The race goes through them in order.':
    'Postawione: {n} z {max}. Kliknij mapę, żeby dodać kolejny punkt, kliknij punkt, żeby go usunąć, albo przeciągnij, żeby go przesunąć. Wyścig przejeżdża przez nie po kolei.',
  'Click the map to drop checkpoint 1, then 2, and so on. The race is routed through them in order.':
    'Kliknij mapę, żeby postawić punkt kontrolny 1, potem 2 i tak dalej. Trasa poprowadzi przez nie po kolei.',
  'Old Town sprint': 'Sprint po Starym Mieście',
  'Race name': 'Nazwa wyścigu',
  'Shown on the tour card and in the results.': 'Widoczna na karcie turnieju i w wynikach.',
  'Ready to race.': 'Można się ścigać.',
  'This region cannot be raced as it is.': 'Na tym obszarze nie da się ścigać w obecnym kształcie.',
  'Could not check it.': 'Nie udało się go sprawdzić.',
  'the server did not say why.': 'serwer nie podał powodu.',

  // regionPicker.ts
  N: 'Pn',
  NE: 'Pn-Wsch',
  E: 'Wsch',
  SE: 'Pd-Wsch',
  S: 'Pd',
  SW: 'Pd-Zach',
  W: 'Zach',
  NW: 'Pn-Zach',
  'Search for a city or a street': 'Szukaj miasta albo ulicy',
  'Search for a place': 'Szukaj miejsca',
  'Drag a corner to resize the box, or drag from inside it to move it.':
    'Przeciągnij róg, żeby zmienić rozmiar prostokąta, albo przeciągnij jego wnętrze, żeby go przesunąć.',
  'Press and drag across the map to draw a box — a single click does not draw one.':
    'Wciśnij i przeciągnij po mapie, żeby narysować prostokąt — samo kliknięcie go nie narysuje.',
  'Both pins are down. Drag one to move it, or choose which one to move and click again.':
    'Obie pinezki już stoją. Przeciągnij jedną, żeby ją przesunąć, albo wybierz, którą przesunąć, i kliknij ponownie.',
  'A race holds at most {n} checkpoints. Click one to remove it.': {
    one: 'Wyścig może mieć tylko jeden punkt kontrolny. Kliknij go, żeby usunąć.',
    few: 'Wyścig może mieć najwyżej {n} punkty kontrolne. Kliknij któryś, żeby go usunąć.',
    many: 'Wyścig może mieć najwyżej {n} punktów kontrolnych. Kliknij któryś, żeby go usunąć.',
  },
  'Drag to turn the grid': 'Przeciągnij, żeby obrócić pole startowe',
  'Checkpoint {n} — click to remove': 'Punkt kontrolny {n} — kliknij, żeby usunąć',
  'Searching…': 'Szukam…',
  'Place search failed.': 'Wyszukiwanie miejsca nie powiodło się.',
  'Nothing found for “{query}”.': 'Nic nie znaleziono dla „{query}”.',
  'Place search is unavailable here — pan and zoom the map instead.':
    'Wyszukiwanie miejsc tu nie działa — przesuń i przybliż mapę ręcznie.',
  'Race distance': 'Długość trasy',
  Streets: 'Ulice',
  Buildings: 'Budynki',
  Download: 'Pobieranie',
  'Loads in about': 'Wczyta się w około',

  // raceChecks.ts
  'Draw a box around the streets': 'Narysuj prostokąt wokół ulic',
  'There is no area yet. Drag across the map to draw a box around the streets you want to race, or press “Use current view” to take everything on screen.':
    'Nie ma jeszcze obszaru. Przeciągnij po mapie, żeby narysować prostokąt wokół ulic, po których chcesz się ścigać, albo naciśnij „Użyj bieżącego widoku”, żeby wziąć wszystko, co widać na ekranie.',
  'No bigger than {max} km²': 'Nie więcej niż {max} km²',
  'The box is {area} km² and the limit is {max} km², because a bigger city takes too long to download and build. Drag a corner inwards to shrink it.':
    'Prostokąt ma {area} km², a limit to {max} km², bo większe miasto za długo się pobiera i buduje. Przeciągnij róg do środka, żeby go zmniejszyć.',
  'At least {min} km²': 'Co najmniej {min} km²',
  'The box is only {area} km², which is too small to fit a race. Drag a corner outwards to take in a few more streets.':
    'Prostokąt ma tylko {area} km² — to za mało, żeby zmieścić wyścig. Przeciągnij róg na zewnątrz, żeby objąć kilka ulic więcej.',
  'A server that can download streets': 'Serwer, który może pobierać ulice',
  'This server is running offline, so a new area only works if somebody has raced it here before. The check at the end will say for certain; the built-in regions always work.':
    'Ten serwer działa offline, więc nowy obszar zadziała tylko wtedy, gdy ktoś już się na nim tutaj ścigał. Sprawdzenie na końcu powie to na pewno; gotowe obszary działają zawsze.',
  'A size that downloads quickly': 'Rozmiar, który szybko się pobierze',
  'This is a big area, so the first download from OpenStreetMap can take a minute or two. You can carry on — it is only slow the first time.':
    'To duży obszar, więc pierwsze pobieranie z OpenStreetMap może potrwać minutę lub dwie. Możesz iść dalej — wolno jest tylko za pierwszym razem.',
  'Place the start': 'Ustaw start',
  'There is no start yet. Click the map where the race should begin.':
    'Nie ma jeszcze startu. Kliknij na mapie miejsce, w którym wyścig ma się zacząć.',
  'Place the finish': 'Ustaw metę',
  'There is no finish yet. Click the map where the race should end.':
    'Nie ma jeszcze mety. Kliknij na mapie miejsce, w którym wyścig ma się skończyć.',
  'There is no finish yet. Place the start first, then click again for the finish.':
    'Nie ma jeszcze mety. Najpierw ustaw start, potem kliknij jeszcze raz, żeby ustawić metę.',
  'Start inside the box': 'Start w prostokącie',
  'The start is outside the box. Only the streets inside it are built, so drag the green pin back in.':
    'Start jest poza prostokątem. Budowane są tylko ulice w jego obrębie, więc przeciągnij zieloną pinezkę z powrotem.',
  'Finish inside the box': 'Meta w prostokącie',
  'The finish is outside the box. Only the streets inside it are built, so drag the chequered pin back in.':
    'Meta jest poza prostokątem. Budowane są tylko ulice w jego obrębie, więc przeciągnij pinezkę w szachownicę z powrotem.',
  'Start and finish apart': 'Start i meta z dala od siebie',
  'Start and finish are only {metres} m apart. If they land on the same street corner the race runs to the far side of the box instead.':
    'Start i meta są tylko {metres} m od siebie. Jeśli trafią na ten sam róg ulicy, wyścig pojedzie zamiast tego na drugi koniec prostokąta.',
  'Checkpoints inside the box': 'Punkty kontrolne w prostokącie',
  'Checkpoint {n} is outside the box, where there are no streets to put it on. Drag it back in, or click it to remove it.':
    'Punkt kontrolny {n} jest poza prostokątem, gdzie nie ma ulic, na których można by go postawić. Przeciągnij go z powrotem albo kliknij, żeby go usunąć.',

  // steps.ts
  '{n} things left before you can continue': {
    one: 'Została jeszcze jedna rzecz, zanim przejdziesz dalej',
    few: 'Zostały jeszcze {n} rzeczy, zanim przejdziesz dalej',
    many: 'Zostało jeszcze {n} rzeczy, zanim przejdziesz dalej',
  },
  '{labels} — see the red items above.': {
    one: '{labels} — patrz czerwona pozycja powyżej.',
    few: '{labels} — patrz czerwone pozycje powyżej.',
    many: '{labels} — patrz czerwone pozycje powyżej.',
  },
  'Click the map where everyone sets off from. It snaps to the nearest street when the city is built, so close is good enough. There is no finish: it is a free drive.': 'Kliknij mapę tam, skąd wszyscy ruszają. Punkt przyciągnie się do najbliższej ulicy, gdy miasto się zbuduje, więc wystarczy w pobliżu. Mety nie ma: to swobodna jazda.',
  'Check the region': 'Sprawdź obszar',
  'The server builds the region once to make sure it can be driven. It is saved in this browser under the name below, so next time it is one click in the lobby.': 'Serwer buduje obszar raz, żeby sprawdzić, czy da się po nim jeździć. Zapisze się w tej przeglądarce pod nazwą poniżej, więc następnym razem to jedno kliknięcie w lobby.',
  'Search above the map, or pick “Move the map” and drag. The right mouse button, or Space held down, moves it at any time.': 'Szukaj nad mapą albo wybierz „Przesuń mapę” i przeciągnij. Prawy przycisk myszy albo przytrzymana spacja przesuwa ją zawsze.',
  'Pick “Draw the box”, then press and drag across the map. Drag a corner to resize it, or the middle to move it.': 'Wybierz „Narysuj prostokąt”, a potem przeciągnij po mapie. Przeciągnij róg, żeby zmienić rozmiar, albo środek, żeby go przesunąć.',
  'What dragging the map does': 'Co robi przeciąganie mapy',
  'Move the map': 'Przesuń mapę',
  'Draw the box': 'Narysuj prostokąt',
  'Kept in this browser with your saved regions, so you do not have to draw it again.': 'Zostaje w tej przeglądarce z twoimi zapisanymi obszarami, więc nie trzeba go rysować od nowa.',
};
